import type {
  ProjectsComposerPromptDraft,
  ProjectsComposerPromptSegment,
  ProjectsComposerStarterBundle,
  ProjectsComposerStarterBundleItem,
} from './projects-composer-editor-draft';

export const starterBundleIdentity = (
  bundle: ProjectsComposerStarterBundle | null | undefined
): string =>
  JSON.stringify(
    bundle
      ? {
          starterId: bundle.starterId,
          leadIn: bundle.leadIn,
          items: bundle.items.map((item) => ({ id: item.id, label: item.label })),
        }
      : null
  );

const starterBundleItemsHaveSameContent = (
  left: readonly ProjectsComposerStarterBundleItem[],
  right: readonly ProjectsComposerStarterBundleItem[]
): boolean =>
  left.length === right.length &&
  left.every((item, index) => {
    const other = right[index];
    return other !== undefined && item.id === other.id && item.label === other.label;
  });

const segmentsHaveSameContent = (
  left: ProjectsComposerPromptSegment,
  right: ProjectsComposerPromptSegment
): boolean => {
  if (left.kind === 'text' && right.kind === 'text') {
    return left.text === right.text;
  }
  if (left.kind === 'skill' && right.kind === 'skill') {
    return (
      left.skill.skillId === right.skill.skillId &&
      left.skill.recordingId === right.skill.recordingId &&
      left.skill.slug === right.skill.slug &&
      left.skill.title === right.skill.title &&
      left.skill.kind === right.skill.kind
    );
  }
  if (left.kind === 'object' && right.kind === 'object') {
    const [a, b] = [left.object, right.object];
    return (
      a.kind === b.kind &&
      a.id === b.id &&
      a.label === b.label &&
      a.patientName === b.patientName &&
      a.avatarSeed === b.avatarSeed &&
      a.documentKind === b.documentKind &&
      a.formTemplate === b.formTemplate
    );
  }
  if (left.kind === 'starter_bundle' && right.kind === 'starter_bundle') {
    return (
      left.bundle.starterId === right.bundle.starterId &&
      left.bundle.leadIn === right.bundle.leadIn &&
      starterBundleItemsHaveSameContent(left.bundle.items, right.bundle.items)
    );
  }
  return false;
};

export const draftsHaveSameContent = (
  left: ProjectsComposerPromptDraft,
  right: ProjectsComposerPromptDraft
): boolean =>
  left.text === right.text &&
  left.segments.length === right.segments.length &&
  left.segments.every((segment, index) => {
    const other = right.segments[index];
    return other !== undefined && segmentsHaveSameContent(segment, other);
  });
